import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import { ActionBar, Button, Modal } from '@beef/ui-kit';
import { CAPTCHA_STATUS } from "../../../../../hoc/CaptchaWithCallbackPopupHOC";
import Captcha from "./components/Captcha/Captcha";
export var CaptchaPopup = function CaptchaPopup(_ref) {
  var _texts$captchaTexts;
  var data = _ref.data,
    onClose = _ref.onClose,
    isLoading = _ref.isLoading;
  var reCaptchaModel = data.reCaptchaModel,
    onBackCallBtnClick = data.onBackCallBtnClick,
    texts = data.texts,
    captchaStatus = data.captchaStatus,
    changeCaptchaStatus = data.changeCaptchaStatus,
    captchaMsg = data.captchaMsg,
    changeCaptchaMsg = data.changeCaptchaMsg,
    captchaToken = data.captchaToken,
    changeCaptchaToken = data.changeCaptchaToken;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    newCaptcha = _useState2[0],
    setNewCaptcha = _useState2[1];
  var handleSubmit = function handleSubmit(e) {
    e.preventDefault();
    if (captchaToken && captchaStatus === CAPTCHA_STATUS.success) {
      onBackCallBtnClick();
      setNewCaptcha(!newCaptcha);
    }
  };
  var inputOnBlur = function inputOnBlur() {
    if (!captchaToken) {
      changeCaptchaStatus(CAPTCHA_STATUS.fail);
      changeCaptchaMsg(texts.captchaTexts.title);
    } else if (captchaToken.length < 5) {
      changeCaptchaStatus(CAPTCHA_STATUS.fail);
      changeCaptchaMsg(texts.captchaTexts.errorMsg);
    } else {
      changeCaptchaStatus(CAPTCHA_STATUS.success);
      changeCaptchaMsg('');
    }
  };
  var inputOnFocus = function inputOnFocus() {
    changeCaptchaMsg('');
  };
  return /*#__PURE__*/React.createElement(Modal, {
    actionBar: /*#__PURE__*/React.createElement(ActionBar, {
      isWithText: true,
      size: "s"
    }, /*#__PURE__*/React.createElement(Button, {
      isLoading: isLoading,
      onClick: handleSubmit,
      "data-t-id": "components-CaptchaPopup"
    }, (_texts$captchaTexts = texts.captchaTexts) === null || _texts$captchaTexts === void 0 ? void 0 : _texts$captchaTexts.button)),
    isOpen: true,
    onClose: onClose,
    size: "s",
    "data-t-id": "components-CaptchaPopup"
  }, /*#__PURE__*/React.createElement(Captcha, _extends({}, reCaptchaModel, {
    changeCaptchaMsg: changeCaptchaMsg,
    changeCaptchaStatus: changeCaptchaStatus,
    changeCaptchaToken: changeCaptchaToken,
    changeNewCaptcha: setNewCaptcha,
    errorMsg: captchaMsg,
    msg: texts.captchaTexts,
    newCaptcha: newCaptcha,
    onBlur: inputOnBlur,
    onFocus: inputOnFocus,
    status: captchaStatus
  })));
};